





































































import { Component, Prop, Vue } from "vue-property-decorator";
import ExpirationItemPanel from "@/general/components/pages/parts/ExpiringPoints/expirationItemPanel.vue";
import commons from "@/common/store/modules/commons";
import { getExpirePointHistoryList } from "@/general/store/api";
import globals from "@/general/store/modules/globals";
import CONST_DATA from "@/general/mixins/const/constData";
import { getThanksOrGrantTypeLabel } from "@/common/assets/js/utils/types";
import AuthStorage from "@/general/utils/auth";

@Component({
  name: "ExpiredPoints",
  components: {
    ExpirationItemPanel
  }
})
export default class ExpiredPoints extends Vue {
  expirationData: any = [];
   //　初期表示の際、これを参照しているのでデータが有無かかわらず、メッセージが表示しているため、１をデフォルトで設定、
   // 実際の処理はサーバーから取得したデータで判断する。
  expirationCnt = 1;
  breadcrumb = [
    {
      text: "",
      url: CONST_DATA.SITE_MAP.TOP_PAGE,
      pageType: "home"
    },
    {
      text: "ポイント確認",
      url: CONST_DATA.SITE_MAP.POINT_CONFIRMATION,

      pageType: "lower"
    },
    {
      text: "有効期限切れのポイント",
      url: "",
      pageType: "lower"
    }
  ];

  pageNavi: Record<string, any> = {
    currentPage: 1,
    prevPageUrl: "",
    nextPageUrl: "",
    maxPage: 0,
    baseUrl: ""
  };

  currentPage!: number;
  expiryPage = "expired";
  searchPage!: string;
  headerHeightToStyle = 0;

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  get pageSize() {
    return commons?.pageSize ? commons.pageSize : 10;
  }

  detail(transaction_details: any) {
    if (transaction_details.grant_criteria) {
      return transaction_details.title;
    } else if (transaction_details.from_user) {
      return transaction_details.title;
    }
    return "";
  }

  getLabel(transactionDetails: any) {
    const { grant_type } = transactionDetails;
    return getThanksOrGrantTypeLabel(grant_type);
  }

  params = {
    expiry_point_type: "expired",
    page: 1,
    search: "",
    transaction_direction: "gaining"
  };

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const pageParam = urlParams.get("page");
    const expiryParam = urlParams.get("expiry_point_type")
      ? (urlParams.get("expiry_point_type") as string)
      : "";
    const searchParam = urlParams.get("search")
      ? (urlParams.get("search") as string)
      : "";

    this.currentPage = pageParam ? parseInt(pageParam) : 1;

    this.expiryPage = expiryParam ? expiryParam : "expired";
    this.searchPage = searchParam ? searchParam : "";

    const response: any = await getExpirePointHistoryList(
      this.expiryPage,
      this.currentPage,
      this.pageSize,
      this.searchPage
    )
      .then((res) => {
        return res;
      })
      .catch(() => {
        window.location.href = CONST_DATA.SITE_MAP.POINT_CONFIRMATION;
        return;
      });

    const prevPage = this.currentPage - 1;

    if (prevPage == 0) {
      const prevPage = 1;
    }
    const nextPage = this.currentPage + 1;
    const count = response.count as number;

    const maxPage =
      count % this.pageSize >= 1
        ? Math.floor(count / this.pageSize) + 1
        : count / this.pageSize;

    this.expirationData = response.results || [];
    // this.conditionsList = [];
    this.expirationCnt = response.count as number;

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl = `${CONST_DATA.SITE_MAP.EXPIRED_POINTS}?`;

    await commons.getBreadcrumb(this.breadcrumb);

    this.pageNavi.maxPage = maxPage;
    this.pageNavi.currentPage = this.currentPage;
    this.pageNavi.baseUrl =
      `${CONST_DATA.SITE_MAP.EXPIRED_POINTS}?` +
      "&search=" +
      this.searchPage +
      "&";

    this.pageNavi.nextPageUrl = this.pageNavi.baseUrl + "page=" + nextPage;

    this.pageNavi.prevPageUrl = this.pageNavi.baseUrl + "page=" + prevPage;
  }

  get link() {
    return `${CONST_DATA.SITE_MAP.EXPIRING_POINTS}`;
  }

  get expirationList() {
    return this.expirationData[0]?.expiration_list;
  }

  get isApiResponse() {
    return true;
    // return this.expirationData[0] != null;
  }

  get expiry_date() {
    return this.expirationData[0]?.expiry_date;
  }

  expiredDetails(id: NumberConstructor) {
    window.location.href = `${CONST_DATA.SITE_MAP.EXPIRED_POINT_DETAILS}?id=${id}`;
  }
}
